import AssociatesReport from './AssociatesReportController';

export default AssociatesReport;
